import api from '@common/configs/api';
import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';

export type ReceivedProps = {
  domain: string;
};

const useShareCustomDomain = (props: ReceivedProps) => {
  const [loading, setLoading] = useState(true);
  const [app, setApp] = useState<any>();
  const [url, setUrl] = useState('');
  const { domain } = props;
  const getAppbyDomain = async () => {
    try {
      const response: AxiosResponse = await api({
        method: 'get',
        url: `v2/apps-domain/${domain.replace(/^https?:\/*/, '')}`,
      });

      const { version = null, appId = null } = response.data || {};

      setApp(response?.data as any);
      if (version == 'v3') {
        setUrl(`/preview/${appId}?locale=ja&hiddenStatusBar=true`);
      } else {
        setUrl(
          `https://share.click.dev/preview/${appId}?locale=ja&hiddenStatusBar=true`
        );
      }
    } catch (err) {
      console.log('err', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAppbyDomain();
  }, []);
  return {
    ...props,
    app,
    url,
    loading,
  };
};

export type Props = ReturnType<typeof useShareCustomDomain>;

export default useShareCustomDomain;
